import BaseApi from 'core/api/BaseApi';
import { denormalizeData } from 'core/utils/api';

export default class UnityId extends BaseApi {
  constructor() {
    super();

    this.client.defaults.headers.get['Content-Type'] = 'application/json';

    this.client.interceptors.response.use(
      response => denormalizeData(this.getData(response)),
      this.handleResponseError
    );
  }

  init = params => {
    return this.client({
      method: 'get',
      url: '/init',
      params,
      withCredentials: true,
    });
  };

  signIn = params => {
    return this.client({
      method: 'post',
      url: '/sign_in',
      params,
      withCredentials: true,
    });
  };

  getInfo = params => {
    return this.client({
      method: 'get',
      url: '/info',
      params,
      withCredentials: true,
    });
  };

  signOut = () => {
    return this.client({
      method: 'delete',
      url: '/sign_out',
      withCredentials: true,
    });
  };
}

export const unityId = new UnityId();
